// §6.1 — the Windows 11 skin: the second implementation, and the one that proves the seam.
//
// Nothing in this directory imports the house skin, and nothing in the house skin imports this
// one (§6.5, enforced by lint and by `tests/arch/boundaries.test.ts`). Where the two look alike —
// the drag wiring in `WindowFrame`, the context menu in `DesktopSurface` — they are alike because
// both go through the same kernel services, not because either borrowed from the other.
import type { UiSkin } from '../contract';
import tokens from './tokens.css?inline';
import './skin.css';
import { windowsKeymap } from './keymap';
import { windowsPolicy } from './policy';
import { windowsSounds } from './sounds';
import { WindowFrame } from './components/WindowFrame';
import { DesktopSurface } from './components/DesktopSurface';
import { Bar } from './components/Bar';
import { Launcher } from './components/Launcher';
import { Dialog } from './components/Dialog';
import { Switcher } from './components/Switcher';
import { LockScreen, LoginScreen, NotificationHost, TrayFlyout } from './components/misc';

export const windows11Skin: UiSkin = {
  id: 'windows11',
  label: 'Windows 11',
  tokens,
  keymap: windowsKeymap,
  policy: windowsPolicy,
  sounds: windowsSounds,
  components: {
    DesktopSurface,
    Bar,
    Launcher,
    WindowFrame,
    Dialog,
    NotificationHost,
    Switcher,
    TrayFlyout,
    LoginScreen,
    LockScreen,
  },
};
